module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G7cV5e/images/cover.jpg?1685327251447",
      "alt": "This image is the cover for the book Tell the Bees I'm Sorry"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tell the Bees I'm Sorry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Physics Grad Student Marcus Fitzhughes agrees to leave New York City with his roommate, Andy, to visit Andy’s uncles in Vermont. Marcus wants to escape the city and his ex-boyfriend, Dan, who hasn’t taken their break up very well.")]), _vm._v(" "), _c('p', [_vm._v("In Vermont, Marcus meets Andy's Uncle Raph, a scarred, handsome man with a mysterious past, who settled there to tend bees and make mead. Marcus feels an unexpected attraction to Raph, an interest and lust which he had thought he'd never he feel again after Dan. Raph seems to have the same feelings about him. But both of them need to find the courage to take a chance on the happiness they deserve.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Felicitas Ivey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0